import LargeSearchFacetsContainer from './Large'
import { SmallSearchContainer } from './Small'

const SearchFacetsContainer = (props) => (
  <>
    <LargeSearchFacetsContainer {...props} />
    <SmallSearchContainer {...props} />
  </>
)

export default SearchFacetsContainer
